(function($, undefined) {
	
	'use strict';
	var utils;
	var panelTriggerBtns;
	var panelCloseBtn;
	var panelCancelBtn;
	var panel;
	
	var lexiqueCache = {};
	
	var openPanel = function(id) {
		panel.addClass('visible');

		$('.lexique-panel-list-item').each(function(){
			$(this).attr('data-search-term', $(this).find('.lexique-panel-title').text().toLowerCase());
		});

		$('.form-input').on('keyup', function(){

			var searchTerm = $(this).val().toLowerCase();

		    $('.lexique-panel-list-item').each(function(){

		        if ($(this).filter('[data-search-term *= ' + searchTerm + ']').length > 0 || searchTerm.length < 1) {
		            $(this).show();
		        } else {
		            $(this).hide();
		        }

		    });

		});
	};
	
	var closePanel = function(id) {
		panel.removeClass('visible');
	};
	
	var stopPropagation = function(e) {
		e.stopPropagation();
	};

	var openWordDefinition = function() {
		var t = $(this);
		var lexiquePanelProcessingCtn = t.closest('.lexique-panel-content-ctn');
		var lexiqueWordDefinitionId = t.attr('data-word-id');
		var listCtn = $('.lexique-panel-list');
		var definitionCtn = $('.lexique-panel-word');
		var contentWrapper = definitionCtn.find('.lexique-word-definition-inner');
		var img = definitionCtn.find('.lexique-word-definition-image');
		var title = definitionCtn.find('.lexique-word-definition-title');
		
		lexiquePanelProcessingCtn.addClass('processing');
		getLexiqueWord(lexiqueWordDefinitionId, function(titleText, imgPath, definition) {
			title.text(titleText);
			if (imgPath.length > 0) {
				img.show();
				img.attr('src', imgPath);
			} else {
				img.hide();
			}
			contentWrapper.html(definition);
			lexiquePanelProcessingCtn.removeClass('processing');
			listCtn.hide();
			definitionCtn.show();
		});

		var returnBtn = definitionCtn.find('.back-button-ctn');
		returnBtn.on('click', closeWordDefinition);
	};

	var closeWordDefinition = function() {
		var listCtn = $('.lexique-panel-list');
		var definitionCtn = $('.lexique-panel-word');
		definitionCtn.hide();
		listCtn.show();
	};
	
	var getLexiqueWord = function(id, callback) {
		if (lexiqueCache[id]) {
			callback(lexiqueCache[id].title, lexiqueCache[id].img, lexiqueCache[id].definition);
		} else {
			utils.getGenData(id, function(response) {
				var titleText = $(response)[0].attributes.field2 ? $(response)[0].attributes.field2.value : "";
				var imgPath = $(response)[0].attributes.field3 ? $(response)[0].attributes.field3.value : "";
				var definition = $(response)[0].attributes.field4 ? $(response)[0].attributes.field4.value : "";
				
				addWordToLexiqueCache(id, titleText, imgPath, definition);
				callback(titleText, imgPath, definition);
			});
		}
	};
	
	var addWordToLexiqueCache = function(id, title, img, definition) {
		var newItem = {
			title: title,
			img: img,
			definition: definition
		};
		lexiqueCache[id] = newItem;
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		panel = $('.lexique-panel-outer');

		panelTriggerBtns = $('.lexique-panel-btn');
		panelCloseBtn = $('.lexique-panel-close-btn');
		panelCancelBtn = $('.lexique-panel-outer .cancel-btn');
		
		if (panel.length > 0) {
			panelTriggerBtns.on('click', openPanel);
			panelCloseBtn.on('click', closePanel);
			panelCancelBtn.on('click', closePanel);
			
			$('.lexique-panel-outer').on('click', closePanel);
			$('.lexique-panel-inner').on('click', stopPropagation);

			$('.lexique-panel-word-btn').on('click', openWordDefinition);
			
			SimpleScrollbar.initEl($('.lexique-panel-list-items')[0]);
		}
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);
